import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import {
    BulkDeleteInventoryItemsInput,
    BulkDeleteInventoryItemsResponse,
    DeleteInventoryItemInput,
    DeleteInventoryItemResponse,
} from '../../types/inventory';

const deleteInventoryItem = async (
    input: DeleteInventoryItemInput,
    sessionId: string | null,
): Promise<DeleteInventoryItemResponse> => {
    const { data } = await axios.post(`${API_URL}/inventory/delete`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

const bulkDeleteInventoryItems = async (
    input: BulkDeleteInventoryItemsInput,
    sessionId: string | null,
): Promise<BulkDeleteInventoryItemsResponse> => {
    const { data } = await axios.post(`${API_URL}/inventory/delete`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useDeleteInventoryItem = (
    options?: UseMutationOptions<DeleteInventoryItemResponse, unknown, DeleteInventoryItemInput>,
) => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (input: DeleteInventoryItemInput) =>
            deleteInventoryItem(input, sessionContext?.sessionId ?? null),
        ...options,
    });
};

export const useBulkDeleteInventoryItems = (
    options?: UseMutationOptions<
        BulkDeleteInventoryItemsResponse,
        unknown,
        BulkDeleteInventoryItemsInput
    >,
) => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (input: BulkDeleteInventoryItemsInput) =>
            bulkDeleteInventoryItems(input, sessionContext?.sessionId ?? null),
        ...options,
    });
};

export function buildBulkDeleteConfirmPhrase(count: number): string {
    return `yes-delete-${count}-items`;
}
